import React, { useEffect, useState, useRef } from 'react';
import { connect } from "react-redux";
import { Redirect, Link } from "react-router-dom";
import * as Tools from "../../helpers/Tools";
import * as types from "../../constants/actionTypes";
import { logUI } from "../../api/andyliticsApi";
import Spinner from '../common/spinner';
import InHomeConfirmationModal from './InHomeConfirmationModal';
import { inHomeWhereErrors, XS_MOBILE, SM_MOBILE, MD_TABLET, LG_TABLET } from '../../constants/textConstants';
import { Typography, ZipCodeWithValidation as ZipCode, Divider, TextFieldWithValidation as TextField, DropDownWithValidation as DropDown, PhoneNumberWithValidation as PhoneNumber, TextAreaWithValidation as TextArea, EmailAddressWithValidation as EmailAddress, Modal } from "../ecosystem/";
import { InHomeMainPanel, InHomeOverviewPanel, InHomeQuestionsHeading, InHomeSplitLayout } from "./layout"


const InHomeWhere = ({ selectedUsers, getVaccinePending, getVaccineResult,
    cancelBooking, getAvailableVaccines, prefilledDataPending, address1, address2, city, state,
    zipCode, email, mobilePhone, preferredLanguage, prefillLanguages, cities, extraNote, getInHomeServices, history,
    validateZipCode, validateZipCodeResultPending, validateZipCodeResult, screenBreakPoint }) => {

    useEffect(() => {
        logUI(`MBHWeb.UI.InHomeSchedulingWhere.Displayed`, new Date(), Tools.getURLPath());
    }, []);

    const [locationInfo, setLocationInfo] = useState({
        address1: address1 || "",
        address2: address2 || "",
        city: city.toLowerCase() || "",
        state: state || "TX",
        zipCode: zipCode || "",
        email: email || "",
        mobilePhone: mobilePhone || "",
        language: preferredLanguage || "",
        extraNote: extraNote
    });

    // the prefill may not have finished fetching by the time the user is on the screen, so let's watch for changes
    useEffect(() => {
        setLocationInfo({
            address1: address1 || "",
            address2: address2 || "",
            city: city.toLowerCase() || "",
            state: state || "TX",
            zipCode: zipCode || "",
            email: email || "",
            mobilePhone: mobilePhone || "",
            language: preferredLanguage || "",
            extraNote: extraNote
        })
    }, [address1, address2, city, state, zipCode, email, mobilePhone, preferredLanguage, prefillLanguages, extraNote])

    const [showModal, setShowModal] = useState(false);

    const initialRender = useRef(true);

    // useEffect(() => {
    //     if (initialRender.current) {
    //         initialRender.current = false
    //     } else if (getVaccineResult && !getVaccineResult.success && getVaccineResult.errorMsg) {
    //         handlePopup();
    //     } else if (getVaccineResult && getVaccineResult.success) {
    //         history.push('/inhomeschedule/s31');
    //     }
    // }, [getVaccineResult])

    useEffect(() => {
        if (initialRender.current) {
            initialRender.current = false
        } else if (validateZipCodeResult && !validateZipCodeResult?.success && validateZipCodeResult?.errorMsg) {
            handlePopup();
        } else if (validateZipCodeResult && validateZipCodeResult?.success) {
            history.push('/inhomeschedule/s3');
        }
    }, [validateZipCodeResult])

    const addressRef = useRef();
    const cityRef = useRef();
    const zipCodeRef = useRef();
    const emailRef = useRef();
    const mobilePhoneRef = useRef();
    const languageRef = useRef();


    const validationInfo = useRef({
        address1: false,
        city: false,
        zipCode: false,
        email: false,
        mobilePhone: false,
        language: false,
    })

    // created languages list so Select component can use array efficiently
    const languages = prefillLanguages?.reduce((acc, curr) => {
        let label = curr.value;
        let value = curr.key;
        acc.push({ label, value })
        return acc
    }, [])



    const handlePopup = () => {
        setShowModal(!showModal)
    }

    const handleInputChange = (event, inputField, isValid) => {
        let optionalFields = ['address2', 'extraNote', 'state']
        if (optionalFields.includes(inputField)) {
            setLocationInfo({ ...locationInfo, [inputField]: event.target.value })
        } else {
            setLocationInfo({ ...locationInfo, [inputField]: event.target.value })
        }
    }
    const childValidationMethod = (inputField, isValid) => {
        validationInfo.current[inputField] = isValid;
    }

    const runChildValidationMethods = () => {
        addressRef.current.childValidationMethod();
        cityRef.current.childValidationMethod();
        zipCodeRef.current.childValidationMethod();
        mobilePhoneRef.current.childValidationMethod()
        emailRef.current.childValidationMethod();
        languageRef.current.childValidationMethod();

    }

    const validateForm = () => {
        let isValid = validationInfo.current.address1 && validationInfo.current.city && validationInfo.current.zipCode && validationInfo.current.email && validationInfo.current.mobilePhone && validationInfo.current.language;
        return isValid;
    }

    //let validateFields = locationInfo?.address1 != "" && locationInfo?.email != "" && locationInfo?.mobilePhone != "" && locationInfo?.city != "" && locationInfo?.state != "" && locationInfo?.language != "" && locationInfo?.zipCode != "";
    let validateFields = () => {
        return (locationInfo?.address1 !== "") &&
                (locationInfo?.city !== "") &&
                (locationInfo?.state !== "") &&
                (locationInfo?.zipCode !== "" && RegExp(/^(?!00000)\d{5}$/).test(locationInfo?.zipCode)) &&
                (locationInfo?.email !== "" && RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/).test(locationInfo?.email)) &&
                (locationInfo?.mobilePhone !== "" && RegExp(/^(?!(\d)\(\1{3}\))(?!(\d)\2{9})(?!(\d)\3{2}.\3{3}.\3{4})(?:\(^[2-9]\d{2}\)|^[2-9]\d{2})(.?)?\d{3}\4\d{4}$/).test(locationInfo?.mobilePhone)) &&
                (locationInfo?.language !== "")
    }

    const onClickPrevious = () => {
        logUI(`MBHWeb.UI.InHomeSchedulingWhere.Previous.Clicked`, new Date(), Tools.getURLPath());
        getInHomeServices(locationInfo, true);
        history.push("/inhomevaccine")
    }

    const onClickNext = () => {
        /*runChildValidationMethods();*/
        /*if (validateForm()) {
            logUI(`MBHWeb.UI.InHomeSchedulingWhere.Next.Clicked`, new Date(), Tools.getURLPath());
            getInHomeServices(locationInfo);           
            validateZipCode(locationInfo?.zipCode);
        }*/
        getInHomeServices(locationInfo);
        validateZipCode(locationInfo?.zipCode);

    }

    const closeModal = () => {
        setShowModal(false);
    }


    const isMobile = ([XS_MOBILE, SM_MOBILE, MD_TABLET]).indexOf(screenBreakPoint) > -1 ? true : false;

    return (
        <>
            <InHomeSplitLayout
                className="inhome-scheduling-where-container"
                progressPercent={1 / 7 * 100}

            >
                <InHomeMainPanel
                    heading="Where would you like to be vaccinated?"
                    subheading="Tell us where you’d like the health professional to meet you and some contact info in case they need to reach out to you."
                    schedulingButtons={{
                        disabledNext: !validateFields(),
                        leftBtnLabel: 'Cancel',
                        leftOnClick: onClickPrevious,
                        rightOnClick: onClickNext
                    }}
                >
                    <div className="row">
                        <div className="col-12 col-lg-10 where-detail-wrapper">
                            {(prefilledDataPending || validateZipCodeResultPending) && <Spinner />}
                            <InHomeQuestionsHeading
                                heading="Service Address"
                            />
                            <div className="row">
                                <div className="col-12 col-lg-6">
                                    <TextField
                                        label="Street address"
                                        id="address1"
                                        name="address1"
                                        value={locationInfo.address1}
                                        onChange={(e, value, isValid) => handleInputChange(e, "address1", isValid)}
                                        required
                                        //ref={addressRef}
                                        errorMsg="Enter a valid street address"
                                    />
                                </div>
                                <div className="col-12 col-lg-6">
                                    <TextField
                                        label="Street address 2"
                                        id="address2"
                                        name="address2"
                                        value={locationInfo.address2}
                                        onChange={(e, value, isValid) => handleInputChange(e, "address2", isValid)}
                                    />
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-lg-6">
                                    <DropDown
                                        label="City"
                                        id="city"
                                        name="city"
                                        value={locationInfo.city}
                                        onChange={(e, value, isValid) => handleInputChange(e, "city", isValid)}
                                        options={cities}
                                        required
                                        errorMsg="Enter a valid city"
                                    />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                    <DropDown
                                        label="State"
                                        id="state"
                                        name="state"
                                        value={locationInfo.state}
                                        onChange={(e, value, isValid) => handleInputChange(e, "state", isValid)}
                                        options={Tools.getStates()}
                                        required
                                        errorMsg="Enter a valid state"
                                    />
                                </div>
                                <div className="col-12 col-md-6 col-lg-3">
                                    <ZipCode
                                        id="zipcode"
                                        name="zipcode"
                                        value={locationInfo.zipCode}
                                        //pattern="/(^\d{5}$)|(^\d{5}-\d{4}$)/"
                                        onChange={(e, isValid) => handleInputChange(e, "zipCode", isValid)}
                                        required
                                    />
                                </div>
                            </div>
                            <Divider mTop={isMobile ? "none" : "xsmall"} mBottom={isMobile ? "none" : "xsmall"} mLeft="none" mRight="none" />

                            <InHomeQuestionsHeading
                                heading="Contact Information"
                            />
                            <div className="row">
                                <div className="col-12 col-lg-6">
                                    <EmailAddress
                                        label="Email address"
                                        id="emailaddress"
                                        name="emailaddress"
                                        value={locationInfo.email}
                                        onChange={(e, isValid) => handleInputChange(e, "email", isValid)}
                                        //ref={emailRef}
                                        required
                                    />
                                </div>
                                <div className="col-12 col-lg-6">
                                    <DropDown
                                        label="Language"
                                        id="language"
                                        name="language"
                                        value={languages ? locationInfo.language : ''} // value can be set before options have generated so waiting for options before passing value
                                        onChange={(e, value, isValid) => handleInputChange(e, "language", isValid)}
                                        options={languages}
                                        //ref={languageRef}
                                        required
                                        errorMsg="Select a valid language"
                                    />
                                </div>
                            </div>

                            <div className="row">
                                <div className="col-12 col-lg-6">
                                    <PhoneNumber
                                        label="Mobile phone"
                                        id="mobilePhone"
                                        name="mobilePhone"
                                        value={locationInfo.mobilePhone}
                                        required
                                        onChange={(e, isValid) => handleInputChange(e, "mobilePhone", isValid)}
                                        errorMsg="Enter a valid mobile phone number"
                                    />
                                </div>
                            </div>
                            <Typography
                                type="body-02"
                            >
                                By providing BSWH your mobile number, you agree to receive text messages from BSWH and/or vendor partners regarding the status of your vaccination appointment. Standard data and message rates apply.
                            </Typography>

                            <Divider mTop={isMobile ? "small" : "medium"} mBottom={isMobile ? "none" : "xsmall"} mLeft="none" mRight="none" />

                            <InHomeQuestionsHeading
                                heading="Additional Information"
                                subheading="Notes to Provider regarding your location or contact information."
                            />
                            <TextArea
                                rows="4"
                                maxLength={500}
                                value={locationInfo.extraNote}
                                id="extraNote"
                                name="extraNote"
                                onChange={(e) => handleInputChange(e, "extraNote", true)}
                            />
                        </div>
                    </div>
                    <InHomeConfirmationModal />
                </InHomeMainPanel>
                {
                    showModal && <>
                        <Modal
                            isOpen={showModal}
                            //onCloseClick={closeModal}
                            //className="inhome-modal"
                            modalHeader={<>
                                {validateZipCodeResult?.errorMsg === inHomeWhereErrors.noVax ?
                                    "There are no vaccine appointments available at this time." :
                                    validateZipCodeResult?.errorMsg === inHomeWhereErrors.notInServiceArea ?
                                        "In-home vaccinations are not available in this area." :
                                        validateZipCodeResult?.errorMsg === inHomeWhereErrors.notValidZip ?
                                            "Incorrect ZIP Code"
                                            :
                                            "Oops, something went wrong."
                                }
                            </>}
                            modalBody={<>
                                {validateZipCodeResult?.errorMsg === inHomeWhereErrors.noVax ?
                                    "You can change your location or come back later and try again." :
                                    validateZipCodeResult?.errorMsg === inHomeWhereErrors.notInServiceArea ?
                                        "You can try a different zip code or check back again later. We’ll be expanding our service area soon." :
                                        validateZipCodeResult?.errorMsg === inHomeWhereErrors.notValidZip ?
                                            `The ZIP code you entered is not valid for ${locationInfo.city.toUpperCase()}. Please try again.`
                                            :
                                            "Please try again later if the issue persists." || `${validateZipCodeResult?.errorMsg}`
                                }
                            </>}
                            modalFooterButtons={
                                validateZipCodeResult?.errorMsg === inHomeWhereErrors.noVax || validateZipCodeResult?.errorMsg === inHomeWhereErrors.notInServiceArea ?
                                    [{ label: "Update location", onClick: closeModal },
                                    { label: "Cancel booking", onClick: cancelBooking }]
                                    :
                                    [{ label: validateZipCodeResult?.errorMsg === inHomeWhereErrors.notValidZip ? 'Try again' : 'Okay', onClick: closeModal }]
                            }
                        />

                    </>

                }
                <InHomeOverviewPanel locationPhase={true} />
            </InHomeSplitLayout>
        </>
    );
}
const mapStateToProps = state => {
    const prefilledData = state.inHome.prefilledData;

    // if user has updated the form,  it will get saved as service location
    const serviceLocation = state.inHome.serviceLocationContactInfo

    return {
        selectedUsers: state.inHome.selectedUsers,
        prefilledDataPending: state.inHome.prefilledDataPending,
        profileList: state.memberships.profileList,
        address1: serviceLocation ? serviceLocation.address1 : prefilledData?.address1 || "",
        address2: serviceLocation ? serviceLocation.address2 : prefilledData?.address2 || "",
        city: serviceLocation ? serviceLocation.city : prefilledData?.city || "",
        state: serviceLocation ? serviceLocation.state : prefilledData?.state || "",
        zipCode: serviceLocation ? serviceLocation.zipCode : prefilledData?.zipCode || "",
        email: serviceLocation?.email ? serviceLocation.email : prefilledData?.email || "",
        mobilePhone: serviceLocation?.mobilePhone ? serviceLocation.mobilePhone : prefilledData?.mobilePhone || "",
        preferredLanguage: serviceLocation?.language ? serviceLocation.language : prefilledData?.preferredLanguage || "en",
        prefillLanguages: prefilledData?.languages,
        cities: prefilledData?.cities,
        extraNote: serviceLocation?.extraNote ? serviceLocation.extraNote : "",
        getVaccinePending: state.inHome.getVaccinePending,
        getVaccineResult: state.inHome.getVaccineResult,
        validateZipCodeResultPending: state.inHome?.validateZipCodeResultPending,
        validateZipCodeResult: state.inHome?.validateZipCodeResult,
        screenBreakPoint: state.common.screenBreakPoint,
    }
}

const mapDispatchToProps = dispatch => {
    return {
        getInHomeServices: (address) => {
            dispatch({ type: types.SET_INHOME_LOCATION, address });
        },
        getAvailableVaccines: () => {
            dispatch({ type: types.GET_INHOME_VACCINES })
        },
        cancelBooking: () => {
            dispatch({ type: types.CANCEL_INHOME_BOOKING });
        },
        validateZipCode: (zipCode) => { dispatch({ type: types.VALIDATE_INHOME_ZIPCODE, zipCode }) }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InHomeWhere);